import * as React from 'react';
import { RouteObject } from 'react-router-dom';

const ClientFinancials = React.lazy(
    () => import(/* webpackChunkName: "client-exports" */ '../../../../containers/Client/Financials')
);

export const ClientFinancialsRoutes: RouteObject = {
    path: 'financials',
    element: (
        <React.Suspense fallback={<>...</>}>
            <ClientFinancials />
        </React.Suspense>
    )
};
